import {Module} from "vuex";
import {RootState} from "@/store/types";
import {ReportsState} from "@/store/settings/reports/types";
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: ReportsState = {
  reports: [],
  reportStatusList: [
    'NEW',
    'IN_PROCESS',
    'FINISHED',
    'FAILED',
  ],
}

export const reports: Module<ReportsState, RootState> = {
  state,
  getters,
  actions,
  mutations
}